"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerNavigationLinkIdsSchema = void 0;
const navigationLinkMapping_1 = require("./navigationLinkMapping");
const zod_1 = require("zod");
exports.PlayerNavigationLinkIdsSchema = zod_1.z
    .object({
    team: navigationLinkMapping_1.NavigationLinkMappingSchema,
    game: navigationLinkMapping_1.NavigationLinkMappingSchema,
    competition: navigationLinkMapping_1.NavigationLinkMappingSchema,
    keeper: navigationLinkMapping_1.NavigationLinkMappingSchema,
})
    .strict();
//# sourceMappingURL=playerNavigationLinkIds.js.map